// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G7D-","content":"styles_content__EJDHt","row":"styles_row__DmuEk","footer":"styles_footer__3Uvgm","phraseLength":"styles_phraseLength__Q2OUJ"};